import * as React from 'react';

import { PageTitleBar } from 'components';

const CategoryHeader = ({ children }: React.PropsWithChildren<unknown>) => (
  <PageTitleBar headerTitle={children} />
);

export { CategoryHeader };
